module.exports = __webpack_public_path__ + "img/2389.62e446de.gif";